module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topAD",
    attrs: {
      "id": "topAD"
    }
  }, [_c('img', {
    staticClass: "fr",
    attrs: {
      "src": _vm.imgPath + 'close_b.png'
    },
    on: {
      "click": _vm.closeAD
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "fr",
    style: ('color:' + _vm.topObj.btn_clor + ';border-color:' + _vm.topObj.btn_clor),
    attrs: {
      "href": _vm.topObj.jump_url
    }
  }, [_vm._v(_vm._s(_vm.topObj.btn_text))]), _vm._v(" "), (_vm.topObj.pic_url) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.topObj.pic_url
    }
  }) : _c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/logo/logo_red1024x388.png"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fa2d77a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/topAd.vue
// module id = 334
// module chunks = 0